import { FC, MouseEventHandler, ReactNode } from "react";

interface IExternalLink {
  href: string;
  label: ReactNode;
  className?: string;
  dataTestId?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

const ExternalLink: FC<IExternalLink> = ({
  href,
  label,
  className,
  dataTestId,
  onClick,
}) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className={className}
    data-testid={dataTestId}
    onClick={onClick}
  >
    {label}
  </a>
);

export default ExternalLink;
